import { render } from "./MotherLineNavigation.vue?vue&type=template&id=1520e984"
import script from "./MotherLineNavigation.vue?vue&type=script&lang=js"
export * from "./MotherLineNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__